import { usePage } from '@/hooks/use-page';
import api from '@/services/api/api';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export const useGetAttachmentPresign = (
  forceDownload = false,
  {
    isCreditRequest = false,
    parentId = '',
    fetchUrl = false,
  }: { isCreditRequest?: boolean; parentId?: string; fetchUrl?: boolean } = {},
) => {
  const { alertStatus } = usePage();

  return useMutation({
    mutationKey: ['attachment/presign-download/short'],
    mutationFn: async (name: string) => {
      if (!name) return null;

      const response = await api.get(
        isCreditRequest
          ? `/credit-request/${parentId}/attachment/${name}/download`
          : `/attachment/presign-download/short`,
        {
          params: {
            force_download: forceDownload ? 1 : 0,
            filename: name,
          },
        },
      );

      if (response.status !== 200) throw new Error('Error downloading file');
      if (!fetchUrl) return response.data;

      const responseFile = await axios.get(response.data);
      return responseFile.data;
    },
  });
};
